import { html } from 'lit';

/**
 * Client-side password rules — for instant UX feedback only. The authoritative
 * enforcement (these rules + the Have I Been Pwned breach check) lives server-side
 * in mv-backend-worker/src/utils/passwordPolicy.js. Keep the two in sync.
 */
export function passwordRules(pw) {
  const s = pw || '';
  return [
    { label: 'Minstens 8 tekens', ok: s.length >= 8 },
    { label: 'Minstens 1 hoofdletter', ok: /[A-Z]/.test(s) },
    { label: 'Minstens 1 cijfer', ok: /[0-9]/.test(s) },
    { label: 'Minstens 1 speciaal teken', ok: /[^A-Za-z0-9]/.test(s) },
  ];
}

export function passwordMeetsRules(pw) {
  return passwordRules(pw).every((r) => r.ok);
}

/** A live checklist (green when met). Pass the current password value. */
export function passwordChecklist(pw) {
  return html`
    <ul style="list-style:none; margin:8px 0 0; padding:0; display:flex; flex-direction:column; gap:3px;">
      ${passwordRules(pw).map((r) => html`
        <li style="font-size:0.8rem; color:${r.ok ? '#15803d' : 'var(--mv-text-sub,#9ca3af)'}; display:flex; align-items:center; gap:6px;">
          <span style="font-weight:800;">${r.ok ? '✓' : '○'}</span>${r.label}
        </li>`)}
    </ul>
  `;
}
